// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ctJj","colBig":"styles_colBig__32wXX","colSmall":"styles_colSmall__8w267"};